import {AssociateProject} from "../models/basic/project";
import {URLS} from "./app-urls";
import {AbstractService, Expands, Filters} from "./abstract-service";
import {ConfirmationPoMonitoringNre, PoMonitoring, PoMonitoringDashboard} from "../models/basic/po-monitoring";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";
import {Paginated, PaginatedResult} from "../models/default/paginated-result";
import {AxiosResponse} from "axios";
import {Material} from "../models/basic/material";

export type PoMonitoringFilter = Filters & {
    text?: string,
    status?: string,
    client?: string,
    ordering?: string,
};

export interface LastUpdatedPo {
    last_updated: string;
}

export class PoMonitoringService extends AbstractService<PoMonitoring> {

    constructor() {
        super(URLS.PO_MONITORING);
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        if (processedFilter?.client === "0") {
            delete processedFilter.client;
        }

        if(processedFilter.status) {
            if(processedFilter.status === "0") {
                delete processedFilter.status;
            }
        }

        return processedFilter;
    }

    async getDashboard(filters?: PoMonitoringFilter, pagination?: Paginated): Promise<AxiosResponse<PoMonitoringDashboard>> {
        const path = `${this.path}dashboard/`;

        const allParams = this.processParameters(filters, [], pagination);
        return await trackPromise(Api.get(path, {params: allParams} ));
    }

    async associateWithProjects(id: number, projects: AssociateProject[]): Promise<AxiosResponse<{projects: AssociateProject[]}>> {
        const path = `${this.path}${id}/associate-with-projects/`;

        return await trackPromise(Api.post(path, {projects}));
    }

    async getMaterials(id: number, filters?: Filters, expand?: Expands): Promise<AxiosResponse<Material[]>> {
        const path = `${this.path}${id}/list-materials/`;

        const allParams = this.processParameters(filters, expand);
        return await trackPromise(Api.get(path, {params: allParams} ));
    }

    async getPaginatedMaterials(id: number, filters?: Filters, pagination?: Paginated): Promise<AxiosResponse<PaginatedResult<Material>>> {
        const path = `${this.path}${id}/list-materials/`;

        const allParams = this.processParameters(filters, [], pagination);
        return await trackPromise(Api.get(path, {params: allParams} ));
    }

    async getLastUpdated(): Promise<AxiosResponse<LastUpdatedPo>> {
        const url = `${this.path}/last_updated_po/`;
        return await trackPromise(Api.get<LastUpdatedPo>(url));
    }

    async confirmationNre(pagination?: Paginated, search?: string) : Promise<AxiosResponse<PaginatedResult<ConfirmationPoMonitoringNre>>> {
        const path = `${this.path}confirmation/nre`;
        const expands = ['supplier'];
        const filter = search ? {text: search} : {};

        const allParams = this.processParameters(filter, expands, pagination);
        return await trackPromise(Api.get(path, {params: allParams} ));
    }

    async confirmAsNre(obj: any): Promise<AxiosResponse<void>> {
        const path = `${this.path}confirmation/nre/confirm_as_nre/`;
        return await trackPromise(Api.post(path, obj));
    }

    async confirmationNreRemoved(pagination?: Paginated, search?: string) : Promise<AxiosResponse<PaginatedResult<ConfirmationPoMonitoringNre>>> {
        const path = `${this.path}confirmation/nre/list_removed/`;
        const filter = search ? {text: search} : {};

        const allParams = this.processParameters(filter, [], pagination);
        return await trackPromise(Api.get(path, {params: allParams}));
    }

}
